/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audio_Recorder_Drag_LabelInputs */



/**
* | output |
* | --- |
* | "Drag to reposition modal" |
*
* @param {Audio_Recorder_Drag_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_recorder_drag_label = /** @type {((inputs?: Audio_Recorder_Drag_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Recorder_Drag_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Glisser pour repositionner la boîte de dialogue")
	if (locale === "de") return /** @type {LocalizedString} */ ("Zum Neupositionieren des Modals ziehen.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Trascina per riposizionare la finestra modale")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Перетащите для изменения положения модального окна.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Arrastre para reposicionar el modal")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("拖动以重新定位模态框")
	if (locale === "ja") return /** @type {LocalizedString} */ ("ドラッグしてモーダルの位置を変更します")
	if (locale === "hi") return /** @type {LocalizedString} */ ("मोडल को स्थानांतरित करने के लिए खींचें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Arraste para reposicionar o modal.")
	return /** @type {LocalizedString} */ ("Drag to reposition modal")
});